/* SMA: Größen-/Optionsfelder je nach aktueller Auswahl durchstreichen.
   Ein Wert gilt als lieferbar, wenn es eine lieferbare Variante mit diesem Wert
   und den aktuell gewählten Werten der VORHERIGEN Optionen gibt
   (Herkunft hängt von nichts ab, Textur von der Herkunft, Länge von Herkunft + Textur). */
(function () {
  function parse(el) {
    if (el._smaVariants) return el._smaVariants;
    try { el._smaVariants = JSON.parse(el.getAttribute('data-sma-variants')); } catch (e) { el._smaVariants = null; }
    return el._smaVariants;
  }
  function update(root) {
    var variants = parse(root);
    if (!variants || !variants.length) return;
    var groups = root.querySelectorAll('.swatch[data-option-index]');
    if (!groups.length) return;
    var selected = {};
    groups.forEach(function (g) {
      var idx = parseInt(g.getAttribute('data-option-index'), 10);
      var checked = g.querySelector('input[type="radio"]:checked');
      selected[idx] = checked ? checked.value : null;
    });
    groups.forEach(function (g) {
      var idx = parseInt(g.getAttribute('data-option-index'), 10);
      g.querySelectorAll('.swatch-element').forEach(function (el) {
        var input = el.querySelector('input[type="radio"]');
        if (!input) return;
        var value = input.value;
        var ok = variants.some(function (v) {
          if (!v[3] || v[idx] !== value) return false;
          // nur die davor liegenden Optionen berücksichtigen (Herkunft -> Textur -> Länge)
          for (var j = 0; j < idx; j++) {
            if (selected[j] !== undefined && selected[j] !== null && v[j] !== selected[j]) return false;
          }
          return true;
        });
        el.classList.toggle('soldout', !ok);
        el.classList.toggle('available', ok);
      });
    });
  }
  function updateAll() {
    document.querySelectorAll('[data-sma-variants]').forEach(update);
  }
  function later(root) {
    setTimeout(function () { root ? update(root) : updateAll(); }, 0);
    setTimeout(function () { root ? update(root) : updateAll(); }, 150);
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('.swatch input[type="radio"]')) return;
    var root = t.closest('[data-sma-variants]');
    if (root) later(root);
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('.swatch-element');
    if (!t) return;
    var root = t.closest('[data-sma-variants]');
    if (root) later(root);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { later(); });
  else later();
  window.addEventListener('load', function () { later(); setTimeout(updateAll, 800); });
  // Quick-View / Drawer-Inhalte, die später eingefügt werden
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) {
      for (var k = 0; k < m[i].addedNodes.length; k++) {
        var n = m[i].addedNodes[k];
        if (n.nodeType === 1 && (n.matches('[data-sma-variants]') || n.querySelector('[data-sma-variants]'))) { later(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
